import styled from '@emotion/styled'
import { Item } from '../../Item'

export const IconBase = styled(Item)`
  justify-content: center;
`
